import React from "react";
import Alert from "@mui/material/Alert";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { NoItemsFound } from "../publisher/NoItemsFound";
import { Link, useParams } from "react-router-dom";
import { Path } from "../Path";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Image from "@mui/icons-material/Image";
import PictureAsPdf from "@mui/icons-material/PictureAsPdf";
import Box from "@mui/material/Box";
import { formatBytes } from "./formatBytes";
import { formatFullDate } from "@seabrookstudios/pitch2table-core";
import Delete from "@mui/icons-material/Delete";
import { LiveVersionChip } from "../core/LiveVersionChip";

/**
 * @param {Object} props
 * @param {import("@seabrookstudios/pitch2table-core").Rules} props.item
 * @param {number} props.filteredIndex
 * @param {number} props.filteredCount
 */
export const RulesListEntry2 = ({ item, filteredIndex, filteredCount }) => {
  const params = useParams();

  const selected = params.attachmentId === item.id;

  const Icon = item.mimeType === "application/pdf" ? <PictureAsPdf /> : <Image />;

  return (
    <ListItemButton alignItems="flex-start" selected={selected} component={Link} to={Path.game(item.gameId).rule(item.id)}>
      <ListItemText
        primary={
          <Stack direction="row">
            <Box pl={0} pr={1}>
              {item.deleted ? <Delete /> : Icon}
            </Box>
            <Typography variant="inherit">{item.name || `v${filteredCount - filteredIndex}`}</Typography>
          </Stack>
        }
        secondary={`${formatBytes(item.bytes, 1)} - Uploaded: ${formatFullDate(item.uploadedTimestamp)}`}
      />
      <LiveVersionChip gameId={item.gameId} filteredIndex={filteredIndex} />
    </ListItemButton>
  );
};

export const NoRules = () => (
  <NoItemsFound>
    <Alert severity="info">
      Here you can upload your game's rules as discrete versions. As publishers review games at different speeds, your
      game and the rules may have evolved since you pitched it. In the publisher interest section, you can record what
      version of the rules you sent to each publisher.
    </Alert>
  </NoItemsFound>
);
